/**
 * Mobile detection and responsive utilities
 */

let isMobile = false;

// Check if device is mobile
export function checkIfMobile() {
  isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  return isMobile;
}

export function getIsMobile() {
  return isMobile;
}

// Initialize mobile detection and responsive behavior
export function initializeMobileSupport() {
  console.log('Initializing mobile support...');
  
  // Initial mobile check
  checkIfMobile();
  console.log('Is mobile:', isMobile);
  
  // Handle window resize for mobile/desktop transitions
  window.addEventListener('resize', function() {
    const wasMobile = isMobile;
    checkIfMobile();
    
    // Close menu on resize transitions
    if (wasMobile !== isMobile) {
      closeMenu();
    }
  });
  
  // Close menu when clicking outside (but not immediately on load)
  setTimeout(() => {
    document.addEventListener('click', function(event) {
      const menuToggle = document.getElementById('menu-toggle');
      const stickyMenuToggle = document.getElementById('sticky-menu-toggle');
      const headerControls = document.getElementById('header-controls');
      
      if (headerControls && headerControls.classList.contains('menu-open')) {
        if (!headerControls.contains(event.target) && 
            menuToggle && !menuToggle.contains(event.target) &&
            stickyMenuToggle && !stickyMenuToggle.contains(event.target)) {
          closeMenu();
        }
      }
    });
    
    // Prevent menu close when clicking inside the menu
    const headerControls = document.getElementById('header-controls');
    if (headerControls) {
      headerControls.addEventListener('click', function(event) {
        event.stopPropagation();
      });
    }
  }, 100);
  
  console.log('Mobile support initialized successfully');
}

// Toggle unified menu (works for both mobile and desktop)
export function toggleMenu() {
  console.log('Toggling menu...');
  
  const menuToggle = document.getElementById('menu-toggle');
  const stickyMenuToggle = document.getElementById('sticky-menu-toggle');
  const headerControls = document.getElementById('header-controls');
  const overlay = document.getElementById('menu-overlay');
  
  console.log('Elements found:');
  console.log('- menuToggle:', menuToggle);
  console.log('- stickyMenuToggle:', stickyMenuToggle);
  console.log('- headerControls:', headerControls);
  console.log('- overlay:', overlay);
  
  if (!headerControls || !overlay) {
    console.error('Menu elements not found - headerControls:', headerControls, 'overlay:', overlay);
    return;
  }
  
  const isOpen = headerControls.classList.contains('menu-open');
  console.log('Menu is currently:', isOpen ? 'open' : 'closed');
  
  if (isOpen) {
    closeMenu();
  } else {
    console.log('Opening menu...');
    
    // Position menu at current viewport position
    const scrollY = window.scrollY;
    headerControls.style.top = `${scrollY}px`;
    
    // Prevent background scrolling while allowing menu scrolling
    document.body.style.overflow = 'hidden';
    
    headerControls.classList.add('menu-open');
    overlay.classList.add('active');
    if (menuToggle) {
      menuToggle.classList.add('active');
      console.log('Main menu toggle classes:', menuToggle.className);
      
      // Force animation styles as fallback (in case CSS specificity issues)
      const spans = menuToggle.querySelectorAll('span');
      if (spans.length >= 3) {
        spans[0].style.transform = 'rotate(45deg) translate(6px, 6px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(6px, -6px)';
      }
    }
    if (stickyMenuToggle) {
      stickyMenuToggle.classList.add('active');
      console.log('Sticky menu toggle classes:', stickyMenuToggle.className);
    }
    
    console.log('Menu opened - headerControls classes:', headerControls.className);
    console.log('Menu opened - overlay classes:', overlay.className);
  }
}

// Close unified menu
export function closeMenu() {
  console.log('Closing menu...');
  
  const menuToggle = document.getElementById('menu-toggle');
  const stickyMenuToggle = document.getElementById('sticky-menu-toggle');
  const headerControls = document.getElementById('header-controls');
  const overlay = document.getElementById('menu-overlay');
  
  if (headerControls) {
    headerControls.classList.remove('menu-open');
    // Don't reset top position immediately - let the animation complete first
    setTimeout(() => {
      headerControls.style.top = '0';
    }, 300); // Wait for menu close animation
  }
  
  if (overlay) overlay.classList.remove('active');
  if (menuToggle) {
    menuToggle.classList.remove('active');
    console.log('Main menu toggle classes after close:', menuToggle.className);
    
    // Reset animation styles
    const spans = menuToggle.querySelectorAll('span');
    if (spans.length >= 3) {
      spans[0].style.transform = '';
      spans[1].style.opacity = '';
      spans[2].style.transform = '';
    }
  }
  if (stickyMenuToggle) {
    stickyMenuToggle.classList.remove('active');
    console.log('Sticky menu toggle classes after close:', stickyMenuToggle.className);
  }
  
  // Restore body scrolling
  document.body.style.overflow = '';
  
  console.log('Menu closed');
}

// Legacy function aliases for backwards compatibility
export function toggleMobileMenu() {
  toggleMenu();
}

export function closeMobileMenu() {
  closeMenu();
}